import {Pagination} from '@/components';
import type {PaginationProps} from '@/components/common/Pagination';
import {TableSkeleton} from '@/components/Table/TableSkeleton';

import AffiliateReferralsFilters from './AffiliateReferralsFilters';
import AffiliateReferralsTable from './AffiliateReferralsTable';
import useAffiliateReferrals from './useAffiliateReferrals';

export const AffiliateReferralsTab = () => {
  const {
    referrals,
    isLoading,
    error,
    pageInfo,
    displayPage,
    isPageReset,
    filterCount,
    filtersToApply,
    fetchList,
    disqualify,
    clearFilters,
    selectAppliedFilters,
    handleApplyFilters,
  } = useAffiliateReferrals();

  const renderList = () => {
    if (isLoading) {
      return <TableSkeleton />;
    }
    if (error && !referrals.length) {
      return (
        <p className="py-10 text-center text-red-500">
          Failed to load referrals. Try reloading the page.
        </p>
      );
    }
    if (!referrals.length) {
      return (
        <p className="py-10 text-center text-gray-500 dark:text-gray-400">
          No referrals found.
        </p>
      );
    }
    return (
      <>
        {error ? (
          <p
            className="pb-4 text-red-500"
            data-testid="affiliate-referrals-stale"
          >
            Failed to refresh referrals, so the list below may be out of date.
            Try reloading the page.
          </p>
        ) : null}
        <AffiliateReferralsTable items={referrals} onDisqualify={disqualify} />
      </>
    );
  };

  return (
    <div className="w-full">
      <AffiliateReferralsFilters
        filterCount={filterCount}
        filtersToApply={filtersToApply}
        clearFilters={clearFilters}
        selectAppliedFilters={selectAppliedFilters}
        handleApplyFilters={handleApplyFilters}
      />

      <section className="pt-5">{renderList()}</section>

      {referrals.length ? (
        <Pagination
          onPageChange={fetchList as PaginationProps['onPageChange']}
          total={pageInfo.total}
          isPageReset={isPageReset}
          currentPageOverride={displayPage}
        />
      ) : null}
    </div>
  );
};
